import AdminLayout from '../components/AdminLayout';
import AdminDashboardContent from './DashboardContent';

export default function AdminDashboardPage() {
  return (
    <AdminLayout title="Dashboard">
      <AdminDashboardContent />
    </AdminLayout>
  );
}
